$(document).ready(function(){
	
	$('.s2_image_slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: false,
		variableWidth: true,
		centerMode: true,
		autoplaySpeed: 0,
		speed: 4000,
		cssEase: 'linear',
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			}
		]
	});
	
	$('.review_slide_row').slick({
		dots: true,
		slidesToShow:4,
		slidesToScroll: 1,
		adaptiveHeight: false,
		variableWidth: false,
		centerMode: false,
		arrows:true,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
				slidesToShow:3,
				slidesToScroll: 1,
				centerMode: false,
			  }
			},
			
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow:1,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
				arrows:false,
			  }
			},
		] 
	});
	
	$('.s5_slider_row').slick({
		dots: true,
		slidesToShow:3,
		slidesToScroll: 1,
		adaptiveHeight: false,
		variableWidth: true,
		centerMode: false,
		arrows:false,
		responsive: [
			{
				breakpoint: 1023,
				settings: {
				slidesToShow:2,
				slidesToScroll: 1,
				centerMode: true,
			  }
			},
			
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow:1,
				slidesToScroll: 1,
				centerMode: true,
				variableWidth: true,
				arrows:true,
			  }
			},
		] 
	});
	
	$('.review_row').slick({
		dots: true,
		slidesToShow:3,
		slidesToScroll: 1,
		adaptiveHeight: false,
		variableWidth: false,
		centerMode: false,
		arrows:true,
		responsive: [
			
			{
				breakpoint: 1023,
				settings: {
				slidesToShow:2,
				slidesToScroll: 1,
				centerMode: false,
				variableWidth: true,
			  }
			},
			
			{
			  breakpoint:767,
			  settings:"unslick",
			
			},
		] 
	});
	
	//accordion JS 
	$(".accordion").click(function() {
		
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn_content');
		var idx = $('.acdn_content').index(answerDiv);
		
		$('.acdn_content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.accordion').removeClass('accordion_open');
				});
			}
        });
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion_open');
			});
		} else {
		  questionDiv.addClass('accordion_open');
		  answerDiv.stop().slideDown(500);
		}
	});
	
	var video = $('#myVdo video')[0];
	
	$('.ugc1').click(function(e) {
		$('.ugc-modal').addClass('active');
		$('.video-container').show();
		
		var videoFile = $(this).attr('data-vdo');
		video.src = videoFile;
		video.load();
		video.play();
    });	
	
	$('.ugc-close, .ugc-modal').click(function(e) {
		video.src = '';
       	$('.ugc-modal').removeClass('active');
	   	$('.video-container').hide();
    });
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#select_pkg").offset().top - 55
		}, 2000);
	});
	
	var scroll = new SmoothScroll('a[href*="#"]', {
		speed: 500,
	});
	
	//SELECT COLOR
	$('.color-tog').click(function(e) {
		$('.color-drower').slideUp();
		if ( $(this).next('.color-drower').is(':visible')){
			$(this).next('.color-drower').slideUp();
		}else{
			$(this).next('.color-drower').slideDown();
		}
		
		 event.stopPropagation();
	});
	
	$(document).click(function(e) {
        $('.color-drower').slideUp();
    });
	
	
	$('.colorname-list li').click(function(e) {
		$(this).closest('.color-drower').slideUp();
		$(this).closest('.selct-colorbx').find('.color-tog').html($(this).html());
	});
});
$(document).scroll(function() {
		
	if ($(this).scrollTop() > 110){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
});

//MODAL Shades
function openModal() {
  document.getElementById('shadeModal').style.display = 'block';
}

function closeModal() {
  document.getElementById('shadeModal').style.display = 'none';
}

// Optional: Close the modal if the user clicks outside of it
window.onclick = function(event) {
  let modal = document.getElementById('shadeModal');
  if (event.target == modal) {
    closeModal();
  }
}
